<template>
    <el-dialog width="40%" :visible.sync="is_show" title="客户今年累计打款排名">
        <el-table stripe :data="data" v-loading="is_loading">
            <el-table-column label="#">
                <template slot-scope="scope">
                    {{pai(scope.$index)}}
                </template>
            </el-table-column>
            <el-table-column label="客户简称">
                <template slot-scope="scope">
                    {{scope.row.abridge}}
                </template>
            </el-table-column>
            <el-table-column label="累计打款金额(万元)">
                <template slot-scope="scope">
                    {{scope.row.moneySum}} 万
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer">
            <el-pagination
                @current-change="currentChange"
                hide-on-single-page
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
import request from '@/utils/request'
export default {
    name: 'money_rank',
    data(){
        return {
            is_loading:false,
            data:[],
            total:0,
            is_show:false,
            selectForm:{
                pageSize:10,
                pageNum:1
            }
        }
    },
    methods:{
        showMany(){
            this.selectForm = {
                pageSize:10,
                pageNum:1
            };
            this.getData();
        },
        currentChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        getData(){
            this.is_loading = true;
            request.post("index/year_payment_ranking",this.selectForm).then(res=>{
                this.data = res.data.list;
                this.total = res.data.total;
                this.is_show = true;
                this.is_loading = false;
            }).catch(err=>{
                this.is_show = true;
                this.is_loading = false;
            });
        },
        pai(index){
            return (this.selectForm.pageNum-1)*this.selectForm.pageSize + index + 1;
        }
    },
    created() {

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
